<template>
  <div class="dashboard">
    <section class="section-header">
      <h1>{{ $t('meta.privacy') }}</h1>
    </section>

    <div class="body-content">
      <div class="content-wrap">
        <div class="content-body" style="padding: 40px">
          <h2 style="margin-top: 0">A. Allgemeine Informationen</h2>

          <h3>1. Verantwortliche Stelle und Kontaktdaten</h3>

          <p>Verantwortlich für diese Internetseiten ist</p>

          <p>REMONDIS Assets & Services GmbH & Co. KG Brunnenstr. 138 44536 Lünen</p>

          <p>
            Weitere Angaben zu unserem Unternehmen sowie Kontaktmöglichkeiten können Sie unserem Impressum entnehmen.
          </p>

          <p>Kontaktdaten unseres Datenschutzbeauftragten:</p>

          <p>
            REMONDIS SE & Co.KG<br />
            Brunnenstraße 138<br />
            44536 Lünen<br />
            datenschutz@remondis.de
          </p>

          <p>
            Die REMONDIS SE & CO. KG fungiert als einheitliche Anlaufstelle für die betroffenen Personen und ist für die
            Informationspflichten gemäß Art. 13 und 14 DSGVO, Datenschutzfolgenabschätzungen gem. Art. 24, 32 DSGVO
            verantwortlich.
          </p>

          <h3>2. Erklärung zur gemeinsamen Verantwortung</h3>

          <p>
            Die REMONDIS SE & Co. KG sowie ihre Tochterunternehmen und verbundene Unternehmen üben in vielen Bereichen
            eine gemeinsame Verantwortung gem. § 26 DSGVO aus. Die Dienstleistungen und Lieferungen werden in der Regel
            durch die Tochterunternehmen unseres Konzerns erbracht, die hierzu auf die zentrale Datenverarbeitung in
            unserem Konzern zurückgreifen. Die gemeinsame Verantwortung erstreckt sich insbesondere auf folgende
            Bereiche:
          </p>

          <p>- Kundendatenbanken</p>
          <p>
            Im Rahmen der gemeinsamen Verantwortlichkeit haben die REMONDIS SE & CO KG sowie ihre Tochterunternehmen und
            verbundene Unternehmen vereinbart, wer von ihnen welche datenschutzrechtlichen Pflichten (insbesondere
            Informationspflichten gem. Art. 13, 14 DSGVO) wahrnimmt. Im Rahmen der gemeinsamen Verantwortlichkeit sind
            die REMONDIS SE & Co. KG sowie das betroffene Tochterunternehmen oder verbundene Unternehmen gemeinsam
            verpflichtet, die gem. Art. 13, 14 DSGVO erforderlichen Informationen zugänglich zu machen. Die Unternehmen
            lassen dem jeweils angefragten Unternehmen die notwendigen Informationen aus ihrem Wirkbereich zukommen. Die
            Unternehmen informieren sich unverzüglich gegenseitig über die von Betroffenen geltend gemachten
            Rechtspositionen und stellen einander alle für die Beantwortung von Auskunftsersuchen notwendigen
            Informationen zur Verfügung. Datenschutzrechte können gegenüber allen beteiligten Unternehmen geltend
            gemacht werden. Darüber hinaus kann es bei einigen Verarbeitungen zu einer gemeinsamen Verantwortlichkeit
            von REMONDIS-Unternehmen untereinander oder mit Dritten kommen. Auf diese wird im Rahmen der jeweiligen
            Verarbeitung (Teil B) eingegangen.
          </p>

          <h3>3. Datenkategorien, Zwecke und Rechtsgrundlagen der Datenverarbeitungen</h3>

          <p>
            Wir verarbeiten Ihre personenbezogenen Daten nach den Vorschriften der Datenschutz-Grundverordnung (DSGVO)
            und dem Bundesdatenschutzgesetz (BDSG) sowie allen weiteren geltenden Rechtsvorschriften. Die Erhebung und
            Verarbeitung der Daten bestimmen sich nach der von Ihnen gewählten Leistung bzw. Information.
          </p>
          <p>Allgemein erheben wir folgende Informationen:</p>

          <ul>
            <li>Name, Vorname, Anrede</li>
            <li>E-Mail-Adresse</li>
            <li>Kommunikationsdaten (IP-Adresse, Geräte-Informationen)</li>
          </ul>

          <p>
            Die spezifischen Datenerhebungen und Verarbeitungen können Sie den einzelnen Verarbeitungen (Teil B) sowie
            den jeweiligen Bestimmungen unserer Vertragsunterlagen entnehmen.
          </p>

          <h3>4. Datenempfänger</h3>
          <p>Wir übermitteln Ihre personenbezogene nur in folgenden Fällen an Dritte:</p>
          <p>
            Die Übermittlung der Daten erfolgt an externe Unternehmen, die in unserem Auftrag aus Auftragsverarbeiter
            tätig sind oder die in unserem Auftrag tätig werden (dies betrifft z.B. externe Rechenzentren, EDV- und
            IT-Anwendungen, Webseitenmanagement etc.)
          </p>
          <p>
            Die Übermittlung der Daten erfolgt zur Abwicklung eines Vertragsverhältnisses mit Ihnen gem. Art. 6 Abs. 1
            S. 1 lit. b DSGVO (z.B. an ein verbundenes Unternehmen im Konzern (vgl. Ziffer 2) oder einen
            Unterauftragsnehmer oder an ein Logistikunternehmen).
          </p>

          <h3>5. Löschung der Daten und Dauer der Speicherung</h3>

          <p>
            Grundsätzlich verarbeiten und speichern wir Ihre Daten nur für die Dauer unserer Geschäftsbeziehung
            einschließlich der Anbahnung und Abwicklung des Vertrages sowie der gesetzlichen Aufbewahrungsfristen.
          </p>
          <p>
            Sind die Daten für die Erfüllung vertraglicher oder gesetzlicher Pflichten und Rechte nicht mehr
            erforderlich, werden diese regelmäßig gelöscht, es sei denn, deren - befristete - Weiterverarbeitung ist zur
            Erfüllung der vorstehend aufgeführten Zwecke aus einem überwiegenden berechtigten Interesse erforderlich.
          </p>
          <p>
            Soweit einzelne Verarbeitungen personenbezogener Daten andere Löschfristen erforderlich machen, werden diese
            bei der Beschreibung der einzelnen Verarbeitungen unter Ziffer B erwähnt.
          </p>

          <h3>6. Verarbeitung Ihrer Daten in einem Drittland</h3>

          <p>
            Eine Datenübermittlung an Stellen in Drittländern (Staaten außerhalb der Europäischen Union (EU) bzw. des
            Europäischen Wirtschaftsraums (EWR) erfolgt nur dann, wenn es zur Ausführung eines Auftrages/Vertrags von
            bzw. mit Ihnen erforderlich sein sollte, es gesetzlich vorgeschrieben ist (z.B. steuerrechtliche
            Meldepflichten), angemessene Datenschutzniveaus vorliegen oder Sie uns eine Einwilligung erteilt haben.
          </p>

          <p>
            Die Verarbeitung Ihrer Daten in einem Drittland kann auch im Zusammenhang mit der Einschaltung von
            Dienstleistern im Rahmen der Auftragsverarbeitung erfolgen. Soweit für das betreffende Land kein Beschluss
            der EU-Kommission über ein dort vorliegendes angemessenes Datenschutzniveau vorliegen sollte, stellen wir
            durch entsprechende Verträge sicher, dass ihre Rechte und Freiheiten angemessen geschützt und garantiert
            werden. Entsprechende Detailinformationen entnehmen Sie den Einzelbeschreibungen der Verarbeitungen unter
            Ziffer B.
          </p>

          <p>
            Informationen zu den geeigneten oder angemessenen Garantien und zu der Möglichkeit, eine Kopie von Ihnen zu
            erhalten, können auf Anfrage beim Datenschutzbeauftragten angefordert werden.
          </p>

          <h3>7. Ihre Rechte als betroffene Person</h3>

          <p>
            Auf Anfrage werden wir Ihnen schriftlich oder elektronisch darüber Auskunft erteilen, ob und welche Daten zu
            Ihrer Person bei uns gespeichert sind (Art. 15 DSGVO) sowie Ihre Eingaben zur Löschung (Art. 17 DSGVO),
            Berichtigung (Art. 16 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO) sowie Übermittlung (Art. 20
            DSGVO) Ihrer personenbezogenen Daten prüfen und bei Vorliegen der Voraussetzungen durchführen.
          </p>
          <p>Bitte wenden Sie sich hierzu an:</p>
          <p>REMONDIS SE & Co. KG - Datenschutzbeauftragter - Brunnenstr. 138 44536 Lünen  datenschutz@remondis.de</p>
          <p>
            Soweit Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten rechtswidrig erfolgt,
            können Sie sich bei einer Aufsichtsbehörde beschweren (§ 77 DSGVO). Eine Liste der Datenschutzbeauftragten
            sowie deren Kontaktdaten können Sie folgendem Link
            entnehmen: https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.
          </p>

          <h3>8. Belehrung zum Widerspruchsrecht</h3>

          <p>
            Soweit die Verarbeitung Ihrer personenbezogener Daten auf Grund von Art 6 Abs 1 S 1 lit. f DSGVO
            (Datenverarbeitung aufgrund einer Interessenabwägung) oder aufgrund Art. 6 Abs 1 S 1 lit. e DSGVO
            (Datenverarbeitung im öffentlichen Interesse) erfolgt, haben Sie das Recht, jederzeit gegen die Verarbeitung
            Widerspruch einzulegen.
          </p>
          <p>
            Wir verarbeiten die personenbezogenen Daten dann in jedem Fall nicht mehr zu Zwecken des Direktmarketings
            oder eines damit in Verbindung stehenden Profilings und darüber hinaus auch nicht für andere Zwecke, es sei
            denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihren Interessen,
            Rechten und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen. In diesem Fall müssen Sie für den Widerspruch Gründe darlegen, die sich
            aus Ihrer besonderen Situation ergeben.
          </p>

          <p>Ihren Widerspruch sollten Sie möglichst an folgende Kontaktadresse senden:</p>
          <p>datenschutz@remondis.de</p>

          <h3>9. SSL- bzw. TLS-Verschlüsselung</h3>

          <p>
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum
            Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw.
            TLS-Verschlüsselung. Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
            übermitteln, nicht von Dritten mitgelesen werden.
          </p>

          <h2>B. Einzelne Verarbeitungen</h2>
          <h3>1. Anmeldeformular</h3>
          <p>
            Im Rahmen der Nutzung unserer Internetseite wird ein Anmeldeformular eingesetzt. Wir benötigen diese Angaben
            um für Sie einen personalisierten Benutzerprofil zu erstellen. Folgende Angaben von Ihnen werden angefragt:
          </p>
          <ul>
            <li>Anrede </li>
            <li>{{ $t('meta.name') }}</li>
            <li> Vorname </li>
            <li>E-Mail-Adresse</li>
          </ul>
          <p>
            Die Verarbeitung dieser Daten erfolgt zu Zwecken der Authentifizierung. Rechtsgrundlage für diese
            Datenverarbeitung ergibt sich aus dem berechtigten Interesse des Betreibers der Webseite nach Art. 6 Abs. 1
            lit. f DSGVO.
          </p>
          <h3>2. Externes Hosting</h3>
          <p>
            Diese Website wird bei einem externen Dienstleister gehostet. Personenbezogenen Daten, die auf dieser
            Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um
            IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Kontaktdaten, Namen, die über eine Website
            generiert werden, handeln.  Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber
            unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren,
            schnellen und effizienten Bereitstellung unserer Webseite durch einen professionellen Anbieter (Art. 6 Abs.
            1 lit. f DSGVO).  Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner
            Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.  Wir setzen
            folgenden Hoster ein: 
          </p>

          <p>
            Microsoft Ireland Operations Limited<br />
            South County Industrial Park City<br />
            Dublin 18<br />
            Ireland
          </p>

          <h3>3. Einbindung von MapBox</h3>

          <p>
            Wir nutzen MapBox API (nachfolgend nur „MapBox“ genannt) zur Darstellung interaktiven Karten. Damit Ihnen
            die Karte angezeigt werden kann, wird Ihre IP-Adresse an MapBox weitergeleitet. Wie MapBox Ihre Daten
            speichert, können Sie auf der Datenschutzseite von MapBox hier https://www.mapbox.com/legal/privacy/
            einsehen.
          </p>

          <p>Anbieter von MapBox ist der MapBox Inc:</p>
          <p>
            MapBox Inc. 740 15th Street NW 5th Floor,<br />
            Washington<br />
            District of Columbia 20005<br />
            USA
          </p>

          <p>
            Wir stützen den Einsatz der vorgenannten Tools auf Art. 6 Abs. 1 Buchst. f) DSGVO: die Datenverarbeitung
            ergibt sich aus unserem Bedarf an einer ansprechenden Tourdarstellung auf unserer Webseite und liegt daher
            in unserem berechtigten Interesse. 
          </p>

          <h3>4. Übersicht Cookies</h3>

          <p>
            Bei Cookies handelt es sich um kleine Textdateien, die durch Ihren Browser auf Ihrer Festplatte gespeichert
            werden. Normalerweise sorgt Ihr Browser dafür, dass unsere Cookies nur an unsere Internetpräsenz zurück
            übermittelt werden. Falls Sie keine Cookies auf Ihrem Computer (oder einem anderen Gerät) zulassen möchten,
            können Sie diese in Ihrem Internet-Browser deaktivieren. Allerdings kann dies die Benutzerfreundlichkeit und
            Funktionalität der Website beeinträchtigen. Rechtsgrundlage für die Datenverarbeitung durch Cookies zum
            Zwecke des Betriebs der Internetseite ist Art. 6 Abs. 1 lit. f DSGVO. Unsere Website nutzt die folgenden
            Cookies:
          </p>

          <p>
            “binity_token”: Local Storage: Ist zwingend erforderlich um den Nutzer zu authentifizieren und
            Session-Informationen abzulegen.
          </p>
          <p>“mapbox.eventData”: Wird von Mapbox gesetzt um die Karten darzustellen.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  data() {
    return {}
  },
  methods: {},
  mounted() {},
}
</script>

<style lang="scss"></style>
